import { ExceptionService } from '../services/exception.service';
import {
  Component, Input, Output, EventEmitter, OnInit, AfterContentChecked,
  ElementRef
} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { TogetherAuctionDIPSolicitorRequest, TogetherBaseAddress } from './../models/api.models';
import { TogetherDIPStageContainer, TogetherDIPState } from './../models/app.models';
import { NodeAPIEntityService } from './../services/node.entity.service';
import { TogetherAuctionDIPEntityType } from './../models/enums';
import { AddressComponent } from 'app/components/address.component';
import { Router } from '@angular/router';
import * as _ from 'lodash-es';

/**
 *
 *
 * @export
 * @class TogetherAuctionDIPSolicitorsComponent
 * @implements {OnInit}
 */
@Component({
    selector: 'together-auction-dip-solicitors-details',
    templateUrl: './dip.solicitors_details.component.html',
    providers: [NodeAPIEntityService],
    standalone: false
})
export class TogetherAuctionDIPSolicitorsComponent implements OnInit {


  tad_solicitor_required: UntypedFormControl = new UntypedFormControl(null, []);
  tad_solicitor_name: UntypedFormControl = new UntypedFormControl(null, [
    Validators.required
  ]);
  tad_solicitor_firm_name: UntypedFormControl = new UntypedFormControl(null, [
    Validators.required,
    Validators.minLength(1),
  ]);
  tad_solicitor_firm_address: UntypedFormGroup = new UntypedFormGroup({});
  tad_solicitor_firm_email: UntypedFormControl = new UntypedFormControl(null, [
    Validators.minLength(4),
    // tslint:disable-next-line:max-line-length
    Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
  ]);
  tad_solicitor_firm_phone: UntypedFormControl = new UntypedFormControl(null, [
    Validators.required,
    Validators.minLength(7),
    Validators.pattern(/([0-9]+){7,10}/),
  ]);
  tad_solicitors_details_form: UntypedFormGroup;
  address: TogetherBaseAddress = new TogetherBaseAddress();
  solicitors_details: TogetherAuctionDIPSolicitorRequest =
    new TogetherAuctionDIPSolicitorRequest();
  _isLoading: boolean = false;
  _notifications: Array<object> = [];
  _state: number = TogetherDIPState.New;
  addresslookup: UntypedFormGroup = this.fb.group({});
  isSubmitted: boolean = false;


  @Input() stage: TogetherDIPStageContainer;
  @Input() incoming_case_id: string;
  @Output() stage_changing = new EventEmitter();

  /**
   * JWT Token
   *
   * @type {string}
   */
  jwt_token: string;


  /**
   *
   *
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  ngOnInit() {
    window.scrollTo(0, 0);
    this._handleInit();
    this.onChanges();
  }

  /**
   *
   *
   * @returns {*}
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  onChanges(): any {
    var self = this;
    this.tad_solicitor_required.valueChanges.subscribe((val) => {
      if (val === 'false') {
        if (!_.isNil(this.solicitors_details) &&
          this.entity.isNew(this.solicitors_details.Id) === false) {
          this.deleteSolicitor(this.incoming_case_id,
            this.solicitors_details.Id);
        }
        self.tad_solicitor_name.reset();
        self.tad_solicitor_firm_address.reset();
        self.address = new TogetherBaseAddress();
        self.tad_solicitor_firm_phone.reset();
        self.tad_solicitor_firm_email.reset();
        self.tad_solicitor_firm_name.reset();
      } else {
        if (_.isNil(this.solicitors_details))
          self.solicitors_details = new TogetherAuctionDIPSolicitorRequest();
      }
    });
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  ngAfterContentChecked() {
    this._handleFormSwitch();
    this._handleBindAPIData();
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  _clearErrors() {
    this._notifications = [];
  }

  /**
   *
   *
   * @param {any} error
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  _handleError(error) {
    this._notifications.push({ text: error.error.message });
  }

  /**
   *
   *
   * @param {any} notifications
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  _setErrorNotifications(notifications) {
    this._notifications = notifications;
  }

  /**
   * check for disabling button events
   *
   * @returns
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  _handleDisableButtons() {
    return this.tad_solicitors_details_form.invalid === true;
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  _handleBindAPIData() {
    const address = this.tad_solicitor_firm_address;

    if (_.isNil(this.solicitors_details) === false) {
      this.solicitors_details.CompanyName = this.tad_solicitor_firm_name.value;
      this.solicitors_details.ContactName = this.tad_solicitor_name.value;
      this.solicitors_details.Email = this.tad_solicitor_firm_email.value;
      this.solicitors_details.PhoneNumber = this.tad_solicitor_firm_phone.value;

      const addressInit = Object.keys(address.controls).length > 0;

      if (addressInit) {
        // Bind address
        this.solicitors_details.CaseContactAddressRequest['CaseId'] = this.incoming_case_id;
        this.solicitors_details.CaseContactAddressRequest.HouseName =
          address.get('addressHouseName').value;
        this.solicitors_details.CaseContactAddressRequest.HouseNumber =
          address.get('addressHouseNumber').value;
        this.solicitors_details.CaseContactAddressRequest.District =
          address.get('addressDistrict').value;
        this.solicitors_details.CaseContactAddressRequest.County =
          address.get('addressCounty').value;
        this.solicitors_details.CaseContactAddressRequest.Street =
          address.get('addressStreet').value;
        this.solicitors_details.CaseContactAddressRequest.Street1 =
          address.get('addressStreet').value;
        this.solicitors_details.CaseContactAddressRequest.Street2 =
          address.get('addressStreet').value;
        this.solicitors_details.CaseContactAddressRequest.PostTown =
          address.get('addressTownCity').value;
        this.solicitors_details.CaseContactAddressRequest.Postcode =
          address.get('addressPostcode').value;
      }

    }
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  _prepareInitData() {
    if (_.isNil(this.solicitors_details) === false &&
      _.isNil(this.solicitors_details.CaseContactAddressRequest) === false &&
      this.solicitors_details.CaseContactAddressRequest.Id !== 0) {
      this.address =
        new TogetherBaseAddress(this.solicitors_details.CaseContactAddressRequest);
      this.tad_solicitor_firm_name.setValue(this.solicitors_details.CompanyName);
      this.tad_solicitor_name.setValue(this.solicitors_details.ContactName);
      this.tad_solicitor_firm_email.setValue(this.solicitors_details.Email);
      this.tad_solicitor_firm_phone.setValue(this.solicitors_details.PhoneNumber);
    }
  }


  /**
   *
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  _handleFormSwitch() {
    this._prepareForm(this.tad_solicitor_required.value === 'true');
    this._handleBindAPIData();
  }

  /**
   *
   * @param {any} form
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  _handleIncomingForm(form) {
    this.tad_solicitor_firm_address = form;
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  _handleForward(forward) {
    this.isSubmitted = true;
    if (this._handleDisableButtons() === false) {
      if (this.tad_solicitor_required.value === 'true') {
        this._handleSaveData(this.incoming_case_id,
          this.solicitors_details.Id, this.solicitors_details);
      } else {
        this._handleNextStep();
      }
    } else {
      this.validateAllFormFields(this.tad_solicitors_details_form);
    }
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  _handleNextStep() {
    this._isLoading = true;
    const output = {
      case_id: this.incoming_case_id
    };
    const base64 = btoa(JSON.stringify(output));
    this.entity.getJWT(base64).subscribe(
      (success) => {
        this.jwt_token = (success as any).jwt;
        this.router.navigate(['do_retrieve_jwt', this.jwt_token,
          this.stage.current_stage.forward_reference]);
      },
      (error) => {
        const errorInner = _.defaultTo(error.error, {});
        this.exception.haveReceivedError(errorInner);
      });
  }

  /**
   * method to handle save solicitor
   * @param {any} case_id
   * @param {any} entity_id
   * @param {any} entity
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  _handleSaveData(case_id, entity_id, entity) {
    this._isLoading = true;
    this.solicitors_details.CaseId = this.incoming_case_id;
    this.entity.saveEntities(TogetherAuctionDIPEntityType.SolicitorDetails,
      case_id, entity_id, entity)
      .subscribe(
        (success) => {
          this.solicitors_details = new TogetherAuctionDIPSolicitorRequest(success as Object);
          this._clearErrors();
          this._isLoading = false;
          this._handleNextStep();
        },
        (error) => {
          this.exception.haveReceivedError(error);
          this._isLoading = false;
        });
  }

  /**
   *
   *
   * @param {any} caseId
   * @param {any} solicitorId
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  deleteSolicitor(caseId, solicitorId) {
    if (this.entity.isNew(solicitorId) === false) {
      this._isLoading = true;
      this.entity.deleteEntities(TogetherAuctionDIPEntityType.SolicitorDetails,
        caseId, solicitorId)
        .subscribe(
          (success) => {
            this._clearErrors();
            this._isLoading = false;
          },
          (error) => {
            this.exception.haveReceivedError(error);
            this._isLoading = false;
          });
      this.solicitors_details = null;
    }
  }



  /**
   * handles backward button event
   *
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  _handleBackward(backward) {
    this.stage_changing.emit(this.stage.current_stage.backward_reference);
  }

  /**
   *
   * Retrieves the data for the case from the API.
   *
   * @param {any} case_id
   * @memberof TogetherAuctionDIPLoanDetailComponent
   */
  _handleInitData(case_id) {
    this._isLoading = true;
    this.entity.getAllEntities(TogetherAuctionDIPEntityType.SolicitorDetails, case_id)
      .subscribe(
        (success) => {
          if (_.isArray(success) && (success as Array<any>).length === 0) {
            this._state = TogetherDIPState.RetrievedFromAPI_New;
            this.tad_solicitor_required.setValue('false');
          } else {
            const solicitor = new TogetherAuctionDIPSolicitorRequest(success as Object);
            if (this.entity.isNew(solicitor.Id) === false) {
              this.tad_solicitor_required.setValue('true');
            }
            this.solicitors_details = solicitor;
            this._state = TogetherDIPState.RetrievedFromAPI_Results;
            this._prepareInitData();
          }
          this._clearErrors();
          this._isLoading = false;
        },
        (error) => {
          this.exception.haveReceivedError(error);
          this._isLoading = false;
        });
  }

  /**
   * Determines state of entity.
   *
   * @memberof TogetherAuctionDIPLoanDetailComponent
   */
  _handleInit() {
    // Is the entity not new? If so, let's get the details.
    if (this.entity.isNew(this.incoming_case_id) === false) {
      this._handleInitData(this.incoming_case_id);
    } else {
      // If we're not allowed to have a new reference, move.
      if (this.entity.allowNew(this.stage.current_stage.reference) === false) {
        this.stage_changing.emit('tad_stage_info');
        this._prepareInitData();
      }
    }
  }

  /**
   *
   *
   * @param {boolean} [has_solicitor=false]
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  _prepareForm(hasSolicitor: boolean = false) {
    if (_.isNil(this.tad_solicitor_required.value))
      this.tad_solicitor_required.setValue(_.toString(hasSolicitor));
    if (hasSolicitor) {
      this.tad_solicitors_details_form = this.fb.group({
        tad_solicitor_required: this.tad_solicitor_required,
        tad_solicitor_name: this.tad_solicitor_name,
        tad_solicitor_firm_name: this.tad_solicitor_firm_name,
        tad_solicitor_firm_address: this.tad_solicitor_firm_address,
        tad_solicitor_firm_email: this.tad_solicitor_firm_email,
        tad_solicitor_firm_phone: this.tad_solicitor_firm_phone,
        addresslookup: this.addresslookup,
      });
    } else {
      this.tad_solicitors_details_form = this.fb.group({
        tad_solicitor_required: this.tad_solicitor_required,
      });
    }
  }

  /**
   *
   *
   * @param {string} control
   * @returns
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  setDynamicClasses(control: string) {
    return {
      'is-invalid form-control-danger': this.tad_solicitors_details_form.get(control).touched
        && this.tad_solicitors_details_form.get(control).invalid,
      'is-valid form-control-success': this.tad_solicitors_details_form.get(control).touched
        && this.tad_solicitors_details_form.get(control).valid,
    };
  }

  /**
   *
   *
   * @param {string} control
   * @returns
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  setDynamicClassesForFormgroup(control: string) {
    return {
      'is-invalid': this.tad_solicitors_details_form.get(control).touched
        && this.tad_solicitors_details_form.get(control).invalid,
      'is-valid': this.tad_solicitors_details_form.get(control).touched
        && this.tad_solicitors_details_form.get(control).valid,
    };
  }

  /**
   *
   * Validate all fields on submitiion
   * @param {FormGroup} formGroup
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  validateAllFormFields(formGroup: UntypedFormGroup) {
    // tslint:disable-next-line:no-var-self
    const self = this;
    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  ngAfterViewChecked() {
    if (this.isSubmitted) {
      const element = this.elementRef.nativeElement.querySelector('.is-invalid');
      if (!_.isNil(element)) {
        element.scrollIntoView();
        this.isSubmitted = false;
      }
    }
  }

  /**
   * Creates an instance of TogetherAuctionDIPSolicitorsComponent.
   * @param {FormBuilder} fb
   * @param {NodeAPIEntityService} entity
   * @memberof TogetherAuctionDIPSolicitorsComponent
   */
  constructor(private fb: UntypedFormBuilder,
    private entity: NodeAPIEntityService,
    private elementRef: ElementRef,
    private exception: ExceptionService,
    private router: Router) {
    this._prepareForm(false);
  }
}
